/* Maxximus v2: carga la base, aviso legal, entrega estimada y bloque visual de boxers. */
(() => {
 const me = document.currentScript;
 if (me && me.src) { const b = document.createElement('script'); b.src = me.src.replace('nd-maxximus.js', 'nd-maxximus-base.js'); b.defer = true; document.head.appendChild(b); }

 /* Imágenes que van en TODOS los boxers de hombre (New Collection incluido) */
 const BOXER_GIF = 'https://cdn.shopify.com/s/files/1/0840/9425/5395/files/ezgif-5-f9cc9676d8_1.gif?v=1731685120';
 const SIZE_GUIDE = ''; /* pendiente: URL de la guía de tallas "¡TENEMOS TALLAS PLUS!" */

 const css = document.createElement('style');
 css.textContent = `.nd-block--estimated_shipping,.nd-block--shipping_checkpoints{display:none!important}
 .mx-legal{margin:12px auto 4px;max-width:460px;font-size:11px;line-height:1.55;letter-spacing:.02em;text-align:center;color:#7a7873;font-family:var(--font-body-family,inherit)}
 .mx-legal a{color:#0e0e0e;text-decoration:underline;text-underline-offset:2px}
 .mx-boxer-extra{max-width:560px;margin:8px auto 24px;padding:0 16px;display:flex;flex-direction:column;gap:12px}
 .mx-boxer-extra img{display:block;width:100%;height:auto;border-radius:4px}`;
 document.head.appendChild(css);

 const DAYS = ['dom','lun','mar','mié','jue','vie','sáb'];
 const MONTHS = ['ene','feb','mar','abr','may','jun','jul','ago','sep','oct','nov','dic'];
 const MAX_DAYS = 4;
 const add = (d, n) => { const x = new Date(d); x.setDate(x.getDate() + n); return x; };
 const key = d => `${d.getFullYear()}-${d.getMonth()+1}-${d.getDate()}`;
 const easter = y => { const a=y%19,b=Math.floor(y/100),c=y%100,d=Math.floor(b/4),e=b%4,f=Math.floor((b+8)/25),g=Math.floor((b-f+1)/3),h=(19*a+b-d-g+15)%30,i=Math.floor(c/4),k=c%4,l=(32+2*e+2*i-h-k)%7,m=Math.floor((a+11*h+22*l)/451),mo=Math.floor((h+l-7*m+114)/31),da=((h+l-7*m+114)%31)+1; return new Date(y,mo-1,da); };
 const nextMon = d => { const x = new Date(d); while (x.getDay() !== 1) x.setDate(x.getDate() + 1); return x; };
 const cache = {};
 const holidays = y => { if (cache[y]) return cache[y]; const E = easter(y), s = new Set();
  [[0,1],[4,1],[6,20],[7,7],[11,8],[11,25]].forEach(([m,d]) => s.add(key(new Date(y,m,d))));
  [[0,6],[2,19],[5,29],[7,15],[9,12],[10,1],[10,11]].forEach(([m,d]) => s.add(key(nextMon(new Date(y,m,d)))));
  [-3,-2,43,64,71].forEach(n => s.add(key(add(E,n))));
  return (cache[y] = s); };
 const workable = d => { let x = new Date(d); while (x.getDay() === 0 || holidays(x.getFullYear()).has(key(x))) x = add(x, 1); return x; };
 const bogotaToday = () => { const p = new Intl.DateTimeFormat('en-CA',{timeZone:'America/Bogota',year:'numeric',month:'2-digit',day:'2-digit'}).format(new Date()).split('-').map(Number); return new Date(p[0], p[1]-1, p[2]); };
 const fmt = d => `${DAYS[d.getDay()]} ${d.getDate()} ${MONTHS[d.getMonth()]}`;
 const icon = p => `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${p}</svg>`;
 const ICONS = {
  order: icon('<path d="M6 7h12l-1 13H7L6 7Z"/><path d="M9 7a3 3 0 0 1 6 0"/>'),
  ship: icon('<path d="M3 7h11v9H3z"/><path d="M14 10h4l3 3v3h-7"/><circle cx="7" cy="17.5" r="1.5"/><circle cx="17" cy="17.5" r="1.5"/>'),
  home: icon('<path d="M4 11 12 4l8 7"/><path d="M6 10v10h12V10"/>')
 };
 const buildEta = () => {
  const t = bogotaToday(), ship = workable(add(t, 1)), last = workable(add(t, MAX_DAYS));
  const el = document.createElement('div');
  el.className = 'mx-eta'; el.setAttribute('data-mx-eta','');
  el.innerHTML = `<p class="mx-eta__lead">Pide hoy y recíbelo antes del <strong>${fmt(last)}</strong></p>
  <ol class="mx-eta__steps">
   <li>${ICONS.order}<span class="mx-eta__label">Pedido</span><span class="mx-eta__date">${fmt(t)}</span></li>
   <li>${ICONS.ship}<span class="mx-eta__label">Despacho</span><span class="mx-eta__date">${fmt(ship)}</span></li>
   <li>${ICONS.home}<span class="mx-eta__label">Entrega</span><span class="mx-eta__date">máx. ${fmt(last)}</span></li>
  </ol>`;
  return el;
 };
 const buildLegal = () => {
  const p = document.createElement('p');
  p.className = 'mx-legal'; p.setAttribute('data-mx-legal','');
  p.innerHTML = 'Al hacer clic en el botón de compra o al realizar cualquier pedido en MAXXIMUS aceptas nuestros <a href="/pages/terminos-del-servicio" target="_blank" rel="noopener">Términos y condiciones</a> y nuestra <a href="/pages/politica-de-privacidad" target="_blank" rel="noopener">Política de privacidad y tratamiento de datos personales</a>.';
  return p;
 };
 const hideOldLegal = () => {
  document.querySelectorAll('.product__info-container *:not(script):not(style), [class*="gp-"] p, [class*="gp-"] div').forEach(n => {
   if (n.closest('[data-mx-legal]') || n.children.length > 3) return;
   const t = (n.textContent || '').toLowerCase();
   if (t.length < 400 && t.includes('aceptas nuestros') && (t.includes('terminos') || t.includes('términos'))) {
    const box = n.closest('.nd-block, .product__text, [class*="text"]') || n; box.style.display = 'none';
   }
  });
 };
 const hideOldEta = () => {
  document.querySelectorAll('.shopify-section, .custom-liquid, .nd-block, .product__info-container > *').forEach(sec => {
   if (sec.querySelector('[data-mx-eta]') || sec.querySelector('[data-nd-offers]') || sec.querySelector('.product-form, product-form, ._rsi-buy-now-button')) return;
   const t = (sec.textContent || '').toLowerCase();
   if (t.length < 600 && (t.includes('haz tu pedido dentro de') || (t.includes('despachado') && t.includes('entregado')))) sec.style.display = 'none';
  });
 };
 /* Bloque visual (GIF + guía de tallas) en boxers de hombre, justo después de la ficha del producto */
 const placeBoxerExtra = () => {
  if (document.querySelector('[data-mx-boxer-extra]')) return;
  const offers = document.querySelector('[data-nd-offers]'); if (!offers) return;
  const h1 = document.querySelector('.product__title h1, .product__title, h1');
  const title = ((h1 && h1.textContent) || document.title || '').toLowerCase();
  if (!/b[oó]xer/.test(title) || /(niño|nino|dama|mujer|cachetero)/.test(title)) return;
  const section = offers.closest('.shopify-section'); if (!section) return;
  const wrap = document.createElement('div');
  wrap.className = 'mx-boxer-extra'; wrap.setAttribute('data-mx-boxer-extra','');
  wrap.innerHTML = (BOXER_GIF ? `<img src="${BOXER_GIF}" alt="Boxer Maxximus en movimiento" loading="lazy">` : '') + (SIZE_GUIDE ? `<img src="${SIZE_GUIDE}" alt="Guía de tallas Maxximus: S a 4XL" loading="lazy">` : '');
  section.insertAdjacentElement('afterend', wrap);
 };
 const buttonAnchor = (final) => {
  const rsi = document.querySelector('._rsi-buy-now-button');
  if (rsi) return rsi.parentElement || rsi;
  if (!final) return null;
  return document.querySelector('product-form, form[action*="/cart/add"]');
 };
 const place = (final) => {
  hideOldEta();
  if (document.querySelector('[data-mx-legal]') && document.querySelector('[data-mx-eta]')) return true;
  let legal = document.querySelector('[data-mx-legal]');
  if (!legal) {
   const btn = buttonAnchor(final);
   if (!btn) {
    if (final) { const offers = document.querySelector('[data-nd-offers]'); if (offers && !document.querySelector('[data-mx-eta]')) offers.insertAdjacentElement('afterend', buildEta()); }
    return false;
   }
   hideOldLegal();
   legal = buildLegal();
   btn.insertAdjacentElement('afterend', legal);
  }
  if (!document.querySelector('[data-mx-eta]')) legal.insertAdjacentElement('afterend', buildEta());
  return true;
 };
 const start = () => {
  placeBoxerExtra();
  if (place(false)) return;
  const obs = new MutationObserver(() => { if (place(false)) obs.disconnect(); });
  obs.observe(document.body, { childList: true, subtree: true });
  setTimeout(() => { obs.disconnect(); place(true); hideOldEta(); }, 8000);
 };
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
 document.addEventListener('shopify:section:load', () => { document.querySelectorAll('[data-mx-eta],[data-mx-legal],[data-mx-boxer-extra]').forEach(n => n.remove()); start(); });
})();
